import type { NotificationFormValues } from '../../../../../../../notificationForms/sections/notifications/components/NotificationForm'

import { useCallback } from 'react'

import { useResetEditingState } from '@/atoms'
import { updateCompletedNotificationConfig } from '@/features/domain/territory'
import { useIsUnmounted, useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'

/**
 * That hook returns a submit method for CompletedNotification Form
 */
export function useCompletedNotificationSubmit() {
  const dispatch = useAppDispatch()
  const toast = useNotification()
  const onDiscard = useResetEditingState()
  const isUnMounted = useIsUnmounted()

  return useCallback(
    async (formValues: NotificationFormValues) => {
      try {
        const result = await dispatch(updateCompletedNotificationConfig(formValues))

        if (!updateCompletedNotificationConfig.fulfilled.match(result)) {
          throw new Error(result.payload?.message ?? 'Internal error')
        }

        onDiscard()

        if (isUnMounted()) return
      } catch (error) {
        toast.error(error.message)
      }
    },
    [dispatch, toast, onDiscard],
  )
}
